import { Fonts } from '../../../../../../utils/resources/fonts';
import { Colors } from '../../../../../../utils/resources/colors';
import { ToneCardCSSStyleImpl } from '../tonecard/tonecardcssstyle';

export class ArtistToneCardCSSStyleImpl extends ToneCardCSSStyleImpl
{
    getToneWrapperCSSStyle(marginTop: string): object
    {
        return {
            // height: '364px', 
            // width: '262px', 
            // marginTop: marginTop,
            // marginRight: "1.5%",
            // marginLeft: "1.5%",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'50px 0px 50px 0px'
        };
    }

    getMobileToneWrapperCSSStyle(marginTop: string):object{
        return{
            // height: '152px', 
            // width: '131px', 
            // marginTop: '70px',
            // marginRight: "10px",
            // marginLeft: "10px",
            objectFit: 'cover', 
            position: 'relative',
            cursor: "pointer",
            borderRadius:'25px 0px 25px 0px'
        };
    }
    getOnHoverCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            position: 'absolute',
            height: '280px', 
            width: '262px', 
            borderRadius:'50px 0px 50px 0px',
            display: "flex",
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "20px",
            background: "linear-gradient(0deg, #000000 0%, rgba(0,0,0,0.73) 100%)"
        };
    }

    getImgCSSStyle(): object 
    {
        return {
            objectFit: 'cover', 
            width: '100%', 
            height: '280px',
            borderRadius: "50px 0px 50px 0px",
        };
    }

    getDetailsDivCssStyle(): object 
    {
        return {
            objectFit: 'cover', 
            height: '44px',
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }
    

    getTitleDivCSSStle(): object 
    {
        return {
            height: '44px',
            flex: 1,
        };
    }

    getToneNameCSSStyle(): object {
        return {
            textAlign:"left",
            height: '30px',
            fontWeight: 'bold',
            width: "262px",
            letterSpacing: 0,
            whiteSpace: "nowrap",
            fontSize: this.getResources().getFont(Fonts.h9),
            color:this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px",
            position: 'relative', 
            alignItems: 'left', 
            justifyContent: 'left', 
            top: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }
    getMobileToneNameCSSStyle(): object {
        return {
            textAlign:"left",
            height: '30px',
            fontWeight: 'bold',
            width: "131px",
            letterSpacing: 0,
            whiteSpace: "nowrap",
            fontSize: this.getResources().getFont(Fonts.h7),
            color:this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "30px",
            position: 'relative', 
            alignItems: 'left', 
            justifyContent: 'left', 
            top: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };
    }

    getArtistNameCSSStyle(): object {
        return {
            
            textAlign:"left",
            height: '20px',
            // fontWeight: "500",
            letterSpacing: 0,
            width: "262px",
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: "nowrap",
            fontSize: this.getResources().getFont(Fonts.h8),
            color:this.getResources().getColor(Colors.color_35),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getButtonCSSStyle(): object 
    {
        return {
            height: "28px",
            width: "auto", 
            marginTop: "15px",
            display:'flex'
        };
    }
    getMobileButtonCSSStyle(): object 
    {
        return {
            height: "12px",
            width: "auto", 
            marginTop: "22px",
            display:'flex'
        };
    }

    getTitleCSSStyle(): object {
        return {
            display: "flex",
            textAlign: "center",
            width: '100%', 
            height: '29px',
            fontWeight: "900",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h6),
            color:this.getResources().getColor(Colors.color_9),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            position: 'relative', 
            alignItems: 'center', 
            justifyContent: 'center', 
            top: 0,
        };
    }

    getActionCSSStyle(): object 
    {
        return {
            height: "25px",
            width: "21.5px",
        };
    }

    getDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            width: "151px",
            marginTop: "5px",
            position: "absolute",
            zIndex: 2,
            marginLeft: "31%",
            borderRadius:'25.5px',
            // border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

    getExtraActionDivCSSStyle(width: string): object 
    {
        return {
            width: width, 
            display: "inline-block", 
            alignItems: 'right', 
            justifyContent: 'flex-end',   
            textAlign: "right",
            height: "50px",
            marginRight:'7px'
        };
    }

    
    getHeartDivCSSStyle(): object {
        return {
            width: "30%", 
            display: "inline-block", 
            alignItems: 'left', 
            justifyContent: 'flex-start',   
            textAlign: "left",
            height: "50px",
            marginLeft:'7px'
        };
    }

    getAnnounceDivCSSStyle(): object {
        return {
            width: "35%", 
            display: "inline-block", 
            alignItems: 'center', 
            justifyContent: 'flex-center',   
            textAlign: "center",
            height: "50px",
        };
    }

    getShareDivCSSStyle(): object {
        return {
            width: "30%", 
            display: "inline-block", 
            alignItems: 'right', 
            justifyContent: 'flex-end',   
            textAlign: "right",
            height: "50px",
            marginRight:'7px'

        };
    }
    getActionDivCSSStyle(): object {
        return {
            height: "35px",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/artist/artisttonecardcssstyle.tsx